//dependencias
import React, { Component } from 'react';

//componentes
import BloqueH from './bloqueH'

class Index extends Component {

    render(){
        return(
            <div>
                <BloqueH />
            </div>
        );
    }

}
export default Index;